<template>
  <div
    class="promoCruise-box scroll-container"
    style="display: block"
    v-if="domesticCruiseList.length > 0 || abroadCruiseList.length > 0"
  >
    <div class="promoCruise-title-box">
      <div class="promoCruise-title-hot">
        <img
          src="https://resource.rcclchina.com.cn/tui2/user_center/hot_cruise.png"
        />
      </div>
      <div class="promoCruise-title-text">爆款航线</div>
      <div
        class="promoCruise-title-switch"
        @click="switchRec(nation)"
        v-show="abroadCruiseList.length > 0"
      >
        <img
          src="https://resource.rcclchina.com.cn/tui2/user_center/refresh.png"
        />
        <span class="promoCruise-title-switch-text"
          >换一批{{ !nation ? "海外" : "中国" }}出发航线</span
        >
      </div>
    </div>
    <div class="promoCruise-content-box">
      <div
        class="promoCruise-content-cruise"
        v-for="(item, index) in currentCruiseList"
        :key="item.cruiseId"
      >
        <div
          class="promoCruise-cruise-title promoCruise-link"
          @click="goto(item, index)"
        >
          {{ interceptTitle(item.cruiseName, 50) }}
        </div>
        <div class="promoCruise-cruise-cruiseInfo">
          <div
            @click="goto(item, index)"
            class="promoCruise-cruise-cruiseInfo-pic promoCruise-link"
          >
            <img :src="item.mobileImg" :alt="item.cruiseName" />
          </div>
          <div class="promoCruise-cruise-cruiseInfo-right">
            <div class="promoCruise-cruise-cruiseInfo-prompt"></div>
            <div class="promoCruise-cruise-cruiseInfo-sailDays">
              <span>{{ item.cruiseDateNight }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;<span>{{ item.shipCNName }}</span>
            </div>
            <router-link
              tag="div"
              :to="`/Rccl.Cruise/CruiseSearch/CruiseCalendar?shipCode=${item.shipCode}&sailDate=${item.cruiseSailDate}&routeCode=${item.cruiseName}`"
              class="promoCruise-cruise-cruiseInfo-sailDate"
            >
              <span>{{ item.cruiseSailDate }} - {{ item.cruiseEndDate }}</span>
              <img
                src="https://resource.rcclchina.com.cn/mobileSearchPackage/calendarIcon.png"
                class="js-getCruiseByRoute"
              />
            </router-link>
            <div class="promoCruise-cruise-cruiseInfo-tags promoCruise-link">
              <span
                v-for="(tag, tagIndex) in item.tags"
                :key="tagIndex"
                v-bind:class="{ hot: item.tagViews[tagIndex].isHighShow }"
                @click="toTagLink(item.tagViews[tagIndex].tagLink)"
                >{{ tag }}</span
              >
            </div>
            <div
              class="promoCruise-cruise-cruiseInfo-perPrice promoCruise-link"
            >
              <router-link
                tag="a"
                :to="`/Rccl.Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.cruiseSailDate}`"
                class="external"
              >
                {{
                  item.isRow ? "单船票" : item.isNrp ? "早订特惠价" : "优惠价"
                }}
                ¥
                <span class="promoCruise-cruise-cruisePrice-per">{{
                  item.cruiseBestPrice
                }}</span>
                /人起 &gt;
              </router-link>
              <div>平均每晚 ¥ {{ item.amountPerNight }} /人起</div>
            </div>
            <div
              class="promoCruise-cruise-like js-wishBtn"
              @click="opeWishList(item, index)"
            >
              <img
                v-if="!item.isInWishList"
                class="promoCruise-cruise-not-in-wishlist"
                src="https://resource.rcclchina.com.cn/mobileSearchPackage/likeIcon.png"
              />
              <img
                v-else
                class="promoCruise-cruise-in-wishlist"
                src="https://resource.rcclchina.com.cn/mobileSearchPackage/likeActiveIcon.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { interceptChar } from "@/utilities/tools";
import { gioAdsTracking } from "@/utilities/tools";
import api from "@/api";
export default {
  name: "PromoCruise",
  props: {
    cruiseType: {
      type: Number,
      default() {
        return 0;
      },
    },
    shipCode: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      userToken: "",
      nation: 0,
      currentCruiseList: [],
      domesticCruiseList: [],
      abroadCruiseList: [],
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    async init() {
      const userToken = this.$store.state.user.userToken;
      this.userToken = userToken;

      const promoCruise = await this.getPromoCruiseHP(userToken, 2);
      this.domesticCruiseList = promoCruise.filter(
        (item) => item.isRow === false
      );
      this.abroadCruiseList = promoCruise.filter((item) => item.isRow === true);
      this.currentCruiseList = this.domesticCruiseList;
    },
    async getPromoCruiseHP(userToken, isRow) {
      const { success, data, errMsg } = await api.user.getPromoCruiseHP({
        userToken,
        isRow,
        type: this.cruiseType,
        shipCode: this.shipCode,
      });
      if (!success) {
        console.log(errMsg);
        return null;
      } else {
        return data;
      }
    },
    goto(item, index) {
			const cruiseUrl = item.isRow ? `${process.env.VUE_APP_TUI_URL}/Cruise/MobileCruiseDetail?shipCode=${item.shipCode}&sailDate=${item.cruiseSailDate}`
			: `${process.env.VUE_APP_BASE_URL}/Rccl.Cruise/CruiseDetail?shipCode=${item.shipCode}&sailDate=${item.cruiseSailDate}`;
			gioAdsTracking({
				"adsType": "rcm",
				"rcmOrder": (index+1),
				"desUrl": cruiseUrl
			});
      window.location.href = cruiseUrl;
    },
    switchRec(nation) {
      this.nation = nation ? 0 : 1;
      this.currentCruiseList = this.nation
        ? this.abroadCruiseList
        : this.domesticCruiseList;
    },
    interceptTitle(string, num) {
      return interceptChar(string, num);
    },
    toTagLink(tagLink) {
      if (!tagLink) return false;
      window.location.href = tagLink;
    },
    async opeWishList(item, index) {
      let flag = item.isInWishList;
      if (flag) {
        const { success, data, errMsg } = await api.cruise.deleteWishList({
          userName: this.userToken,
          cruiseId: item.cruiseId,
        });
        if (!success) {
          console.log(errMsg);
        } else {
          console.log(data);
        }
      } else {
        const { success, data, errMsg } = await api.cruise.addWishList({
          userName: this.userToken,
          cruiseId: item.cruiseId,
        });
        if (!success) {
          console.log(errMsg);
        } else {
          console.log(data);
        }
      }
      this.currentCruiseList[index].isInWishList = !flag;
    },
  },
};
</script>

<style scoped>
.promoCruise-box {
  padding: 0;
  text-align: left;
  padding-bottom: 24px;
  display: none;
}

.promoCruise-box .promoCruise-title-box {
  background-color: white;
  position: relative;
  width: 100%;
  padding: 10px 15px 0 15px;
}

.promoCruise-box .promoCruise-title-hot {
  display: inline-block;
  vertical-align: middle;
  width: 13px;
  margin-right: 5px;
}

.promoCruise-box .promoCruise-title-hot img {
  width: 100%;
}

.promoCruise-box .promoCruise-title-text {
  display: inline-block;
  vertical-align: middle;
  
  font-size: 15px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
}

.promoCruise-box .promoCruise-title-switch {
  display: inline-block;
  vertical-align: middle;
  float: right;
}

.promoCruise-box .promoCruise-title-switch img {
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  margin-right: 5px;
}

.promoCruise-box .promoCruise-title-switch .promoCruise-title-switch-text {
  
  font-size: 12px;
  color: #4a90e2;
  letter-spacing: 0;
}

.promoCruise-content-box {
}

.promoCruise-content-box .promoCruise-content-cruise {
  background: #ffffff;
  margin-bottom: 10px;
  padding: 0px 15px;
}

.promoCruise-content-box .promoCruise-cruise-title {
  
  font-size: 13px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
  padding-top: 15px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo {
  margin-top: 9px;
  position: relative;
  padding-bottom: 3px;
}

.promoCruise-cruise-cruiseInfo::after {
  clear: both;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-pic {
  width: 121px;
  height: 150px;
  position: relative;
  overflow: hidden;
  display: inline-block;
  vertical-align: top;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-pic img {
  width: 100%;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-picTitle {
  width: 100%;
  height: 50%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.64) 92%
  );
  
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 1px;
  text-align: center;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-picTitle > span {
  display: inline-block;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 3px;
  transform: scale(0.9);
  -webkit-transform: scale(0.9);
  -moz-transform: scale(0.9);
  -ms-transform: scale(0.9);
  -o-transform: scale(0.9);
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-tips {
  height: 16px;
  line-height: 15px;
  position: absolute;
  top: 4px;
  left: -4px;
  background: #ff5055;
  
  font-size: 11px;
  color: #ffffff;
  letter-spacing: 1.57px;
  text-align: center;
  padding: 0px 5px 0px 6px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-tips::after {
  content: "";
  width: 0;
  height: 0;
  border: 3px solid #d1282d;
  border-bottom-color: transparent;
  border-left-color: transparent;
  position: absolute;
  bottom: -6px;
  left: 0;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-right {
  width: 207px;
  margin-left: 12px;
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-prompt {
  overflow: hidden;
}

.promoCruise-content-box
  .promoCruise-cruise-cruiseInfo-prompt
  > div:first-child {
  padding-left: 0px;
  border-left: none;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-prompt > div {
  float: left;
  padding: 0 12px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-prompt img {
  width: 13px;
  vertical-align: middle;
  font-size: 0;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-sailDays {
  
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  margin-top: 6px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-sailDate {
  margin-top: 2px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-sailDate > span {
  display: inline-block;
  vertical-align: middle;
  
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-sailDate > img {
  width: 16px;
  vertical-align: middle;
  font-size: 0;
  margin-left: 8px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-tags {
  margin: 2px 0;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-tags > span {
  display: inline-block;
  margin: 6px 0 0;
  /*  */
  font-size: 10px;
  color: #4a90e2;
  letter-spacing: 1.43px;
  text-align: center;
  padding: 2px 6px;
  background: rgba(37, 96, 212, 0.05);
  border-radius: 16.37px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-tags > span.hot {
  background: #febc10;
  color: #fff;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-perPrice {
  display: inline-block;
  /* border-bottom: 1px solid #666666; */
  
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  margin-top: 2px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-perPrice a {
  color: inherit;
}

.promoCruise-content-box
  .promoCruise-cruise-cruiseInfo-perPrice
  .promoCruise-cruise-cruisePrice-per {
  
  font-size: 16px;
  color: #ff0000;
  letter-spacing: 0;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-teamPrice {
  
  font-size: 12px;
  color: #666666;
  letter-spacing: 0;
  border: 1px solid rgba(254, 188, 16, 1);
  margin-top: 10px;
  padding-left: 5px;
  position: relative;
  left: -6px;
  height: 25px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-teamPrice > span {
  display: inline-block;
  position: relative;
  top: 2px;
}

.promoCruise-content-box
  .promoCruise-cruise-cruiseInfo-teamPrice
  .promoCruise-cruise-cruisePrice-team {
  
  font-size: 16px;
  color: #ff0000;
  letter-spacing: 0;
  top: 3px;
  margin-left: 2px;
}

.promoCruise-content-box .promoCruise-cruise-cruiseInfo-teamPrice button {
  height: 25px;
  line-height: 25px;
  
  font-size: 12px;
  color: #454545;
  letter-spacing: 0;
  border: none;
  background-image: linear-gradient(270deg, #fad961 0%, #febc10 100%);
  vertical-align: top;
  padding: 0px 11px;
  display: inline-block;
  position: absolute;
  right: 0px;
}

.promoCruise-cruise-like {
  position: absolute;
  right: 0;
  top: 2px;
  width: 40px;
  height: 25px;
}

.promoCruise-cruise-like img {
  position: relative;
  left: 20px;
  width: 20px;
}
</style>
